/*
 * Originally from:
 * https://github.com/zhukov/webogram
 * Copyright (C) 2014 Igor Zhukov <igor.beatle@gmail.com>
 * https://github.com/zhukov/webogram/blob/master/LICENSE
 */

export default function cancelEvent(event?: Event) {
  event ||= window.event;
  if (event) {
    // 'input' event will have cancelable=false, but we still need to preventDefault
    // if(!event.cancelable) {
    //   return false;
    // }

    // @ts-ignore
    event = event.originalEvent || event;

    try {
      if ((event!.stopPropagation as unknown as boolean)) event!.stopPropagation();
      if ((event!.preventDefault as unknown as boolean)) event!.preventDefault();
      event!.returnValue = false;
      event!.cancelBubble = true;
    } catch (err) {}
  }

  return false;
}
